import { AnswerCommand } from 'core/commands/elements/answers/answer.abstract.command';
import { tactileoAnswersDTOTypes } from 'utils/activityItem.util';

export class NotEvaluatedQuestionAnswerCommand extends AnswerCommand {
  constructor(notEvaluatedQuestion) {
    super(tactileoAnswersDTOTypes.ANSWER_QUESTION, notEvaluatedQuestion);
    this.answer = notEvaluatedQuestion.answer;
  }
}
